module.exports = __webpack_public_path__ + "static-portal/img/new8-7.ec50267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new8-7.png
// module id = tdTA
// module chunks = 4